import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { cn } from '@/utils';

interface BannerItem {
  image?: string;
  type?: string;
}

interface BannerSliderProps {
  banners?: BannerItem[];
  className?: string;
  isLoading?: boolean;
}

export const BannerSlider: React.FC<BannerSliderProps> = ({ banners, className, isLoading }) => {
  const navigate = useNavigate();
  const [imagesLoaded, setImagesLoaded] = useState<Record<number, boolean>>({});

  const allLoaded =
    Array.isArray(banners) && banners.length > 0 && banners.every((_, idx) => imagesLoaded[idx]);

  // Show skeleton while data is still fetching OR while images haven't loaded yet
  const showSkeleton = isLoading || !allLoaded;

  return (
    <div className={cn('relative animate-fade-in', className)}>
      <button className="banner-prev rotate-90 absolute left-3 top-1/2 z-10 -translate-y-1/2">
        <i className="icon-arrow-down text-[1.5rem] opacity-70" />
      </button>

      <button className="banner-next -rotate-90 absolute right-3 top-1/2 z-10 -translate-y-1/2 text-white">
        <i className="icon-arrow-down text-[1.5rem] opacity-70" />
      </button>
      {/* ── Slider ── always rendered so images can preload; hidden until ready */}
      {Array.isArray(banners) && banners.length > 0 && (
        <Swiper
          modules={[Autoplay, Navigation]}
          navigation={{
            prevEl: '.banner-prev',
            nextEl: '.banner-next',
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop
          className="w-full h-full"
        >
          {banners.map((banner, idx) => (
            <SwiperSlide key={`${banner.image}-${idx}`}>
              {/* Banners have no per-banner link from the backend (type/image
                  only) — until that exists, every home banner just sends the
                  user to the casino page so all games are reachable from here. */}
              <img
                src={banner.image}
                alt={banner.type}
                className="w-full h-full object-cover cursor-pointer"
                onClick={() => navigate('/casino')}
                onLoad={() => setImagesLoaded((prev) => ({ ...prev, [idx]: true }))}
                onError={() => setImagesLoaded((prev) => ({ ...prev, [idx]: true }))}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};
